import { VscOpenPreview } from "react-icons/vsc";
import { AiOutlineFileDone } from "react-icons/ai";
import { IoMdDoneAll } from "react-icons/io";
import {GiPayMoney,  GiTakeMyMoney } from "react-icons/gi";
import { BiSolidCustomize } from "react-icons/bi";
import { FaShieldAlt } from "react-icons/fa";
import { FaStrava } from "react-icons/fa";
import { FaHandsClapping } from "react-icons/fa6";
import { FaDroplet } from "react-icons/fa6";
import { SiWebmoney } from "react-icons/si";
import { VscCombine } from "react-icons/vsc";
import { FaRupeeSign } from "react-icons/fa";
import { FaCodeCommit } from "react-icons/fa6";
import { TbAdjustmentsCog } from "react-icons/tb";

export const aboutParagraph = "ActoLoan is a digital product of Prakash Chemtex (India) Limited, an RBI-registered NBFC (Reg No: 1400538). We are committed to responsible, transparent digital lending: 100% digital process, instant eligibility check, and secure Aadhaar eSign where applicable. Loan tenures range from 61 days to 365 days; Annual Percentage Rate (APR) ranges from 18% to 42% based on assessment. Transparent pricing with no hidden charges."
export const aboutParagraphHidden= "We deeply understand that financial emergencies require a fast and reliable response. That is why we have engineered a loan application process that is seamless, quick, and transparent from start to finish. Our digital-first philosophy ensures the ultimate convenience: you can initiate and complete your loan application from the comfort of your home and receive approval in just 10 minutes. Say goodbye to lengthy branch visits and complex paperwork."
export const instantloan = " We offer ‘Salary Advance Loan’ designed for salaried employees who need quick cash before their next payday to cover urgent expenses like bills, rent, food, vehicle repair, etc."
export const shortloan = " We offer ‘First-Time Borrower Loan’ designed specifically for individuals who have no prior credit history or have never taken a loan before. It helps them access funds easily while starting to build their credit score."
export const debtConsolidation = "Our ‘Instant/Emergency Loan’ is a quick, easy and hassle-free unsecured personal loan that gets approved and disbursed within minutes, making it ideal for urgent financial needs, such as a medical emergency."
export const secureFuture = "Choosing ActoLoan as your financial partner means you'll get top-notch service designed specifically for your needs. We specialize in personal loans, offering a simple and fast process to apply for loans online. Whether you need money quickly or are facing a financial challenge, ActoLoan provides dependable and speedy solutions. Count on ActoLoan for your personal loan needs and enjoy the ease and confidence that comes with our trusted financial services."
export const weWork = [
    {
        icon:<AiOutlineFileDone className="process_icon" />,
        title: "Application Submission",
        description: "Complete and submit your loan application with the required documents and information on our website."
    },
    {
        icon: <VscOpenPreview className="process_icon" />,
        title: "Application Review",
        description: "ActoLoan will review your application, perform credit checks, and verify your submitted documents."
    },
    {
        icon: <IoMdDoneAll className="process_icon" />,
        title: "Application Approval",
        description: "After verification, you will receive loan approval along with the terms, conditions, and the repayment schedule."
    },
    {
        icon: <GiTakeMyMoney className="process_icon" />,
        title: "Disbursal Initiation",
        description: "Once you accept the terms, the loan amount will be directly transferred to your account, hassle-free."
    }
]

export const advantages = [
    {
        icon: <BiSolidCustomize className="advantage_icon" />,
        title: "10-Minute Transfer",
        description: "Yes, you read that right! We claim that we disburse the loan amount in just 10 minutes."
    },
    {
        icon: <FaStrava className="advantage_icon" />,
        title: "Instant Approval",
        description: "Simple online application process for fast approval and quick disbursal."
    },
    {
        icon: <FaDroplet className="advantage_icon" />,
        title: "Paperless Process",
        description: "Forget the headache of scanning and photocopying documents, as we bring you a 100% paperless process."
    },
    {
        icon: <FaShieldAlt className="advantage_icon" />,
        title: "No Collateral Required",
        description: "Our unsecured personal loans are collateral-free. No need to risk any asset. Just instant funds with PAN and Aadhar."
    },
    {
        icon: <FaHandsClapping className="advantage_icon" />,
        title: "Apply from Anywhere",
        description: " Whether you’re in your office, home, cafe, theatre, mall, or you’re travelling or holidaying, you can effortlessly apply in minutes."
    },
    {
        icon: <SiWebmoney className="advantage_icon" />,
        title: "Zero Hidden Charges",
        description: "We promote zero hidden charges so you can move ahead with us with utmost satisfaction and confidence. "
    },
]

export const services = [
    {
        icon: <GiPayMoney className="services_icon" />,
        title: "Quick Loan",
        description: "We provide instant loans to help you quickly and efficiently handle unexpected financial needs.",
        link:"/instantloan"
    },
    {
        icon: <GiTakeMyMoney className="services_icon" />,
        title: "Short Loan",
        description: "Experience the ease of short-term loans with ActoLoan, crafted to meet your urgent financial needs effortlessly.",
        link:"/shortloan"
    },
    {
        icon: <VscCombine className="services_icon" />,
        title: "Debt Consolidation",
        description: "Gain control of your finances with our debt consolidation services. Combine multiple debts into one easy-to-manage payment.",
        link:"/debtconsolidation"
    },
    {
        icon: <TbAdjustmentsCog className="services_icon" />,
        title: "Flexibility",
        description: "Short-term loans typically offer more flexible eligibility requirements and quicker approval processes.",
        link:"/flexibility"
    },
    {
        icon: <FaCodeCommit className="services_icon" />,
        title: "Minimal Commitment",
        description: "Short-term loans usually have repayment periods that range from a few weeks to a few months.",
        link:"/minimalcommitment"
    },
    {
        icon: <FaRupeeSign className="services_icon" />,
        title: "Cost Effective",
        description: "Although short-term loans may have higher interest rates than long-term loans, the overall cost of borrowing is often lower due to the shorter repayment period.",
        link:"/costeffective"
    },
]

export const aboutUs = "ActoLoan is a digital product of Prakash Chemtex (India) Limited, an RBI-registered NBFC (Reg No: 1400538). We are committed to responsible, transparent digital lending: 100% digital process, instant eligibility check, and secure Aadhaar eSign where applicable. Loan tenures range from 61 days to 365 days; Annual Percentage Rate (APR) ranges from 18% to 42% based on assessment. Transparent pricing with no hidden charges."
export const financialGrowth = "We deeply understand that financial emergencies require a fast and reliable response. That is why we have engineered a loan application process that is seamless, quick, and transparent from start to finish. Our digital-first philosophy ensures the ultimate convenience: you can initiate and complete your loan application from the comfort of your home and receive approval in just 10 minutes. Say goodbye to lengthy branch visits and complex paperwork."
export const faq = [
    {
        ques:"What types of loans does ActoLoan offer?",
        ans:"ActoLoan is a digital product of Prakash Chemtex (India) Limited, an RBI-registered NBFC (Reg No: 1400538). We offer personal loans for eligible salaried customers through a 100% digital process, with instant eligibility check and secure Aadhaar eSign where applicable. Products include One Time Loan and Regular Loan. Tenure is from 7 days to 40 days; Annual Percentage Rate (APR) ranges from 18% to 42%. Transparent pricing with no hidden charges.",
        collapse: "collapseOne"
    },
    {
        ques:"What is the difference between One Time Loan and Regular loan?",
        ans:"A One Time Loan is a single disbursement loan designed for one-time expenses such as medical emergencies, home renovations, or major purchases. A Regular Loan provides ongoing access to funds with flexible withdrawal options, making it ideal for recurring expenses or business needs. Both options have different eligibility criteria and repayment terms.",
        collapse: "collapseTwo"
    },
    {
        ques:"How is loan eligibility determined?",
        ans:"Loan eligibility at ActoLoan is determined based on several factors including your credit score, income stability, employment status, existing financial obligations, and repayment capacity. We use a comprehensive assessment process to ensure fair and transparent loan approvals. Our team reviews each application individually to provide the best possible terms.",
        collapse: "collapseThree"
    },
    {
        ques:"What is the interest rate on a loan?",
        ans:"Pricing is based on Annual Percentage Rate (APR) ranging from 18% to 42%, depending on loan type, amount, tenure (7–40 days), and your credit profile. Transparent pricing with no hidden charges—your APR is disclosed before you complete the loan agreement. Use our on-site loan calculator for an illustrative repayment figure.",
        collapse: "collapseFour"
    },
    {
        ques:"How does the loan application process work?",
        ans:"Start with Check eligibility & apply: verify your mobile with OTP, then complete the digital loan application with your details and documents. Our team reviews eligible applications quickly; disbursal timelines are communicated after approval. The journey is built for speed and clarity at every step.",
        collapse: "collapseFive"
    },
    {
        ques:"What documents are required for loan application?",
        ans:"To apply for a loan with ActoLoan, you will need to provide: Aadhaar Card or PAN Card for identity proof, Address proof (utility bill, rental agreement, or bank statement), Income proof (salary slips, bank statements, or IT returns), Bank account details, and a recent passport-size photograph. All documents should be clear and valid.",
        collapse: "collapseSix"
    },
    {
        ques:"What is the minimum and maximum loan amount I can apply for?",
        ans:"The minimum loan amount at ActoLoan is ₹1,000 and the maximum loan amount can go up to ₹50,000 depending on your eligibility, credit score, and income. The actual loan amount approved will be determined based on our assessment of your repayment capacity and creditworthiness.",
        collapse: "collapseSeven"
    },
    {
        ques:"What is the processing fee and how is it charged?",
        ans:"ActoLoan charges a processing fee of 10% of the loan amount. This fee is deducted from the loan amount at the time of disbursement. For example, if you are approved for a loan of ₹10,000, the processing fee of ₹1,000 will be deducted, and ₹9,000 will be credited to your account. The processing fee is non-refundable.",
        collapse: "collapseEight"
    },
    {
        ques:"How long does it take to get loan approval?",
        ans:"At ActoLoan, we strive to provide quick loan approvals. Once you submit your complete application with all required documents, our team reviews it within 2-3 hours. If approved, the loan amount is typically disbursed to your bank account immediately after approval. The exact timeline may vary based on document verification and bank processing times.",
        collapse: "collapseNine"
    },
    {
        ques:"How do I repay my loan?",
        ans:"Loan repayment at ActoLoan is simple and convenient. Your EMI (Equated Monthly Installment) will be automatically debited from your registered bank account on the due date each month. You can also make manual payments through our website using the \"Pay Now\" option. We recommend ensuring sufficient balance in your account to avoid bounce charges.",
        collapse: "collapseTen"
    },
    {
        ques:"Can I prepay or foreclose my loan early?",
        ans:"Yes, you can prepay or foreclose your loan at any time without any prepayment charges. Early repayment helps you save on interest. To prepay your loan, simply contact our customer support team or use the \"Pay Now\" option on our website. There are no foreclosure charges or penalties for early repayment.",
        collapse: "collapseEleven"
    },
    {
        ques:"What happens if I miss an EMI payment?",
        ans:"If you miss your dues, late payment fees and penal interest apply as specified in your loan agreement. A bounce charge may apply if a payment fails due to insufficient funds. Late payments may affect your credit score. Contact customer support early if you anticipate difficulty meeting a due date.",
        collapse: "collapseTwelve"
    },
    {
        ques:"Is my personal and financial information secure?",
        ans:"Yes, ActoLoan takes data security very seriously. We use SSL encryption for all data transmission, secure servers for data storage, and implement strict access controls. Your personal and financial information is protected according to industry standards. We never share your data with unauthorized third parties. Please refer to our Privacy Policy for detailed information on how we protect your data.",
        collapse: "collapseThirteen"
    },
    {
        ques:"Can I apply for multiple loans?",
        ans:"You can apply for a new loan only after completing repayment of your existing loan with ActoLoan. However, if you have a good repayment history and meet eligibility criteria, you may be eligible for a top-up loan or a new loan application. Each application is assessed individually based on your current financial situation and credit profile.",
        collapse: "collapseFourteen"
    },
    {
        ques:"What is the loan tenure or repayment period?",
        ans:"The loan tenure at ActoLoan ranges from 7 days to 40 days, depending on the loan type and amount. You can choose a repayment period that suits your financial situation.",
        collapse: "collapseFifteen"
    },
    {
        ques:"How can I contact customer support?",
        ans:"You can reach ActoLoan customer support through Email: support@actoloan.com.",
        collapse: "collapseSixteen"
    }
] 

export const termsandconditions = [
    {
        title: "Eligibility:",
        des:"You must be at least 18 years old and a resident of India to use the Site and Services. You must have a valid bank account in India."
    },
    {
        title: "Loan Application:",
        des:"You may apply for loans ranging from 5,000 to 100,000 through the Site. The repayment period for the loan is up to 30 days, with a daily interest rate of 1%. All  applications are subject to approval based on our assessment criteria."
    },
    {
        title: "Loan Approval and Disbursement",
        des:"Once your loan application is approved, the loan amount  will be credited to your designated bank account. Approval and disbursement times may vary  based on the completeness and accuracy of your application and documents. "
    },
    {
        title: "Repayment Terms",
        des:"You agree to repay the loan amount along with applicable interest in  accordance with the repayment schedule provided in your loan agreement. Failure to repay on  time may result in additional charges, legal actions, and may affect your credit score."
    },
    {
        title: "Interest and Fees",
        des:" The interest rate for the loan will be 1% per day. The Annual Percentage Rate (APR) will be calculated based on the daily interest rate annualized. No hidden fees will be  charged; all applicable fees and charges will be clearly disclosed during the application process."
    },
    {
        title: "User Obligations",
        des:"You agree to provide accurate and complete information during the  registration and loan application process. You are responsible for maintaining the confidentiality  of your account information and for all activities that occur under your account."
    },
    {
        title: "Prohibited Activities",
        des:"You agree not to engage in any fraudulent activities or provide false  information. You agree not to use the Site and Services for any illegal or unauthorized purpose."
    },
    {
        title: "Privacy Policy",
        des:"Our Privacy Policy outlines how we collect, use, and protect your personal  information. By using the Site and Services, you agree to our Privacy Policy."
    },
    {
        title: "Intellectual Property",
        des:"All content on the Site, including text, graphics, logos, and images, is the  property of ActoLoan or its content suppliers and is protected by intellectual  property laws. You may not use, reproduce, or distribute any content from the Site without our  prior written permission."
    },
    {
        title: "Modification of Terms",
        des:"We reserve the right to modify these Terms at any time. Any changes  will be effective immediately upon posting on the Site. Your continued use of the Site and  Services after the changes constitutes your acceptance of the revised Terms."
    },
    {
        title: "Termination",
        des:"We may terminate or suspend your access to the Site and Services at any time,  without prior notice or liability, for any reason, including if you breach these Terms."
    },
    {
        title: "Limitation of Liability",
        des:"To the maximum extent permitted by law, ActoLoan  shall not be liable for any indirect, incidental, special, or consequential damages arising out of or  in connection with your use of the Site and Services"
    },
    {
        title: "Governing Law",
        des:"These Terms shall be governed by and construed in accordance with the laws  of India. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of  the courts located in Hisar (Haryana), India."
    },
]

export const howToDeleteData = [
    {
        title:"Open the ActoLoan App",
        des:" Launch the app on your mobile device and log in to your  account."
    },
    {
        title:"Go to Account Settings",
        des:'Navigate to the "Settings" or "Account" section from the main  menu.'
    },
    {
        title:" Request Data Deletion",
        des:'Find the option labeled "Delete Account" or "Request Data  Deletion." Tap on it and follow the on-screen instructions.'
    },
    {
        title:"Confirm Deletion",
        des:"You will be asked to confirm your decision. Please note that this action is  irreversible. Once confirmed, your account and all associated data will be permanently deleted  from our servers."
    },
]

